import React from "react";
import Button from "@material-ui/core/Button";
import {ArrowBackIos} from "@material-ui/icons";
import {makeStyles} from "@material-ui/core/styles";
import {Navigate, useNavigate, useParams} from "react-router-dom";
import Breadcrumbs from "@material-ui/core/Breadcrumbs";
import ReactsCard from "../components/ui/ReactsCard";
import {useTranslation} from "react-i18next";
import {useQuery} from "../utils/function-util";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import {MachineContactList} from "../components/machines/shared/machine-contacts/MachineContactList";

const useStyles = makeStyles(theme => ({
    machineContact: {
        margin: theme.spacing(4),
        '& > *': {
            'margin-bottom': theme.spacing(4)
        }
    },
    top: {
        display: 'flex',
        flexDirection: 'row',
        flexGrow: 1,
        alignItems: 'center'
    },
    actionRow: {
        display: 'flex',
        justifyContent: 'flex-end'
    }
}));

export const MachineContactsView = () => {
    const classes = useStyles();
    const navigate = useNavigate();
    const {machineId, organizationUnitId} = useParams<{machineId: string, organizationUnitId: string}>();
    const {t} = useTranslation();

    const query = useQuery();
    const machineName = query.get('machineName');

    if (!organizationUnitId || !machineId) {
        return <Navigate to='/organization-units' replace={false}/>;
    }

    const goBack = () => {
        navigate(`/organization-units/${organizationUnitId}/detail?tab=1`);
    };


    const goToAdd = () => {
        navigate(`/organization-units/${organizationUnitId}/machines/${machineId}/contacts/add?machineName=${machineName}`);
    };

    return (
        <div className={classes.machineContact}>
            <div className={classes.top}>
                <Button onClick={goBack}>
                    <ArrowBackIos color="primary"/>
                </Button>
                <Breadcrumbs>
                    <Typography color="textPrimary" variant="body1">{machineName}</Typography>
                </Breadcrumbs>
            </div>
            <ReactsCard title={t('Machine.Actions.ManageContacts')}>
                <Grid item xs={12} className={classes.actionRow}>
                    <Button variant="contained" color="primary" size="medium" onClick={() => goToAdd()}>
                        {t('Machine.Contacts.AddContacts.Title')}
                    </Button>
                </Grid>

                <MachineContactList userId={machineId} organizationUnitId={organizationUnitId}/>
            </ReactsCard>
        </div>
    )
};
